/**
 * Client-side CSV download, shared by the admin screens that offer an export.
 *
 * Lifted out of students.tsx when the Messages screen needed the same thing.
 * One copy, because the two details that make an export usable are easy to get
 * subtly wrong and were already right here: fields containing a comma, a quote
 * or a newline are quoted and doubled, and the file opens with a UTF-8 byte
 * order mark so Excel shows "Nguyễn" rather than "NguyÃªÌ„n".
 *
 * Not to be confused with `enrolmentCsvTable` in @alight/contracts, which
 * builds the registration spreadsheet's COLUMNS and is shared with the Worker's
 * live feed. This is only the plumbing that turns rows into a downloaded file.
 */

/** Build a CSV string and trigger a client-side download. */
export function downloadCsv(
  name: string,
  columns: string[],
  rows: Array<Record<string, string | number>>,
): void {
  const escape = (value: string | number): string => {
    const s = String(value);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map(escape).join(",");
  const body = rows
    .map((row) => columns.map((col) => escape(row[col] ?? "")).join(","))
    .join("\n");
  // Prefix BOM (U+FEFF) so Excel reads UTF-8 correctly.
  const csv = `﻿${header}\n${body}`;

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `alight-${name}-${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
